import React from "react"

function affPixel(props) {
  const { s1, s2, s3, s4, s5 } = props.params
  switch (props.params.affid) {
    case "1":
      return (
        <div className="pixel">
          {" "}
          {/* this is 3216's pixel*/}
          <script
            dangerouslySetInnerHTML={{
              __html: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${s3}');
          fbq('track', 'PageView');
        `,
            }}
          />
          <img
            height="1"
            width="1"
            style={{ display: "none" }}
            src={`https://www.facebook.com/tr?id=${s3}&ev=Lead`}
          />
        </div>
      )
      break
    case "2":
      return (
        <div className="pixel">
          {" "}
          {/* this is 3170's pixel*/}
          <script
            dangerouslySetInnerHTML={{
              __html: `
									!function(f,b,e,v,n,t,s)
									{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
									n.callMethod.apply(n,arguments):n.queue.push(arguments)};
									if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
									n.queue=[];t=b.createElement(e);t.async=!0;
									t.src=v;s=b.getElementsByTagName(e)[0];
									s.parentNode.insertBefore(t,s)}(window, document,'script',
									'https://connect.facebook.net/en_US/fbevents.js');
									fbq('init', '${s3}');
									fbq('track', 'CompleteRegistration');
								`,
            }}
          />
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: "none" }}
              src={`https://www.facebook.com/tr?id=${s3}&ev=PageView&noscript=1`}
            />
          </noscript>
        </div>
      )
      break
    case "3959":
      return (
        <div className="pixel">
          <script
            dangerouslySetInnerHTML={{
              __html: `
              !function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?
              p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var
              t=d.createElement(“script”);t.src='https:\/\/www.redditstatic.com/ads/pixel.js',t.async=!0;var
              s=d.getElementsByTagName(“script”)[0];s.parentNode.insertBefore(t,s)}}
              (window,document);rdt(‘init’,‘t2_5h86395f’);rdt(‘track’, ‘PageVisit’);
							`,
            }}
          ></script>
          <script
            dangerouslySetInnerHTML={{
              __html: `rdt('track', 'Lead');`,
            }}
          ></script>
        </div>
      )
      break
    default:
      return null
  }
}

export default affPixel
